export const GET_COMPANIES_FULL_LIST = 'GET_COMPANIES_FULL_LIST'
export const SET_COMPANIES_FULL_LIST = 'SET_COMPANIES_FULL_LIST'
